import idb from "@/api/idb";
import { API_CALLS } from "@/services/apis/index.js";
export default {
  async exportProducts(context, data) {
    return new Promise((resolve, reject) => {
      API_CALLS.exportProductsAPI(data)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getExportHistory() {
    return new Promise((resolve, reject) => {
      API_CALLS.exportHistoryAPI()
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  async deleteCashedProduct(context, sku) {
    await idb.deleteProduct(sku);
    context.state.product = undefined;
  },
  async getCashedProducts(context) {
    context.state.products = [];
    let products = await idb.getProducts();
    products.forEach((c) => {
      context.state.products.push(c);
    });
  },
  async searchForCashedProduct(context, sku) {
    let product = await idb.getProduct(sku);
    context.state.product = product;
  },
  async saveCashedProduct(context, product) {
    await idb.saveProduct(product);
  },
  searchProducts(context, data) {
    return new Promise((resolve, reject) => {
      API_CALLS.searchProductAPI(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  aiAutofill(context, formData) {
    return new Promise((resolve, reject) => {
      API_CALLS.aiAutofill(context, formData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        }
        );
    });
  },
    aiAutofillProducts(context, formData) {
    return new Promise((resolve, reject) => {
      API_CALLS.aiAutofillProducts(context, formData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        }
        );
    });
  },
  postProduct(context, data) {
    return new Promise((resolve, reject) => {
      API_CALLS.addProductAPI(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  getProductLocations(context, sku) {
    return new Promise((resolve, reject) => {
      API_CALLS.getProductLocationAPI(sku)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  //----------PRODUCTS---------------------------
  //search a product by SKU in writing descriptions
  searchSKU(context, data) {
    return new Promise((resolve, reject) => {
      API_CALLS.search_SKU_API(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  //gets PRODUCT data by sku
  //responses could be full or quick (in writing descriptions)
  getDataBySKU(context, data) {
    return new Promise((resolve, reject) => {
      API_CALLS.getDataSKU_API(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putProduct(context, data) {
    return new Promise((resolve, reject) => {
      API_CALLS.putProductAPI(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updatePrices(context, data) {
    return new Promise((resolve, reject) => {
      API_CALLS.updatePrices(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  postNewVariation(context, data) {
    return new Promise((resolve, reject) => {
      API_CALLS.postNewVariationAPI(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  postVariation(context, data) {
    return new Promise((resolve, reject) => {
      API_CALLS.postVariationAPI(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  filterProducts(context, payload) {
    const filters = payload.filters || payload;
    const page = payload.page || 1;
    const limit = payload.limit || 100;
    const isPiguLt = payload.isPiguLt || false;

    return new Promise((resolve, reject) => {
      API_CALLS.filterProductsAPI(filters, isPiguLt, page, limit)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  filterProductsPiguLt(context, payload) {
    // Handle both old format (just data) and new format (object with filters, page, limit)
    const filters = payload.filters || payload;
    const page = payload.page || 1;
    const limit = payload.limit || 100;

    return new Promise((resolve, reject) => {
      API_CALLS.filterProductsAPI(filters, true, page, limit) // true for isPiguLt
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getNotExported() {
    return new Promise((resolve, reject) => {
      API_CALLS.getNotExportedAPI()
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getExported() {
    return new Promise((resolve, reject) => {
      API_CALLS.getExportedAPI()
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getRequiresAttention() {
    return new Promise((resolve, reject) => {
      API_CALLS.getRequiresAttentionAPI()
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putResolvedProduct(context, data) {
    return new Promise((resolve, reject) => {
      API_CALLS.putResolvedProductAPI(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  //------PHOTOS------------------------------
  deletePhoto(context, data) {
    return new Promise((resolve, reject) => {
      API_CALLS.deletePhotoAPI(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getProductPhotos(context, data) {
    return new Promise((resolve, reject) => {
      API_CALLS.getProductPhotosAPI(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  postPhotos(context, data) {
    console.log(context);
    return new Promise((resolve, reject) => {
      API_CALLS.postPhotosAPI(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putOrderedPhotos(context, data) {
    return new Promise((resolve, reject) => {
      API_CALLS.putOrderedPhotosAPI(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  //-----------------------------

  //----LINNWORKS QUANTITY----------------------
  undoUpdateQuantity(context, data) {
    return new Promise((resolve, reject) => {
      API_CALLS.undoUpdateQuantityAPI(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateQuantity(context, data) {
    return new Promise((resolve, reject) => {
      API_CALLS.updateQuantityAPI(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  //---------------------------
  getProductsForPlatformUpload(context, data) {
    console.log(context);
    return new Promise((resolve, reject) => {
      API_CALLS.getProductsForPlatformUploadAPI(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getProductsToTranslate(context, data) {
    return new Promise((resolve, reject) => {
      API_CALLS.getProductsToTranslateAPI(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getDefectDescriptions(context, category) {
    return new Promise((resolve, reject) => {
      API_CALLS.getDefectDescriptionsAPI(category)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  changeStateToNotExported(context, data) {
    return new Promise((resolve, reject) => {
      API_CALLS.changeStateToNotExportedAPI(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  changeLocation(context, data) {
    return new Promise((resolve, reject) => {
      API_CALLS.changeLocationAPI(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getProductsBySkus(context, data) {
    return new Promise((resolve, reject) => {
      API_CALLS.getProductsBySkusAPI(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
